import React from "react"


import FieldStatus_MultiselectValueNotEmpty from "../../../../../generic/status/components/multiselect/value-not-empty"
import FieldProto_AutomationConditionForm from "../../../../../proto/render/automation/automation-condition-form";
import FieldStatus_MultiselectPopoverOption from "../../../../../generic/status/components/multiselect/option";
import SelectMultiGenericNew from "../../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new";


export default class FieldTaskStatus_AutomationConditionForm extends FieldProto_AutomationConditionForm {
    render() {

        const options = gd.session.statuses.toOptions()

        return (
            <div className="flex-row-left-top">
                <div className="label">is</div>
                <SelectMultiGenericNew className                        = "selector w-180"
                                       options                          = {options}
                                       values                           = {this.props.config.fieldValues}
                                       allValuesOptionLabel             = "Any"
                                       popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                       allValuesOption                  = {true}
                                       isSearchable                     = {true}
                                       valueComponent                   = {FieldStatus_MultiselectValueNotEmpty}
                                       popoverOptionComponent           = {FieldStatus_MultiselectPopoverOption}
                                       disabled                         = {this.props.config.disabled}
                                       onChange                         = {this.onChangeFieldValues}/>
            </div>
        )

    }
}
